import { t } from '@lingui/core/macro';
import { extractAmountFromMonetaryValue, MonetaryValue } from '@luminovo/commons';

import { formatCurrency, formattingOptions, FormattingType } from './formatCurrency';
import { getOrCreateNumberFormatter } from './getOrCreateNumberFormat';

type ExchangedMonetaryValueBackend = {
    converted_mv: MonetaryValue;
    original_mv: MonetaryValue;
};

export function formatMonetaryValue(
    monetaryValue: MonetaryValue | ExchangedMonetaryValueBackend | null | undefined,
    formattingType: FormattingType = 'default',
    options?: { ifAbsent?: string; alwaysShowSign?: boolean },
): string {
    if (!monetaryValue) {
        return options?.ifAbsent ?? t`-`;
    }

    const { amount, currency } = 'converted_mv' in monetaryValue ? monetaryValue.converted_mv : monetaryValue;
    const signum = sign(amount, options?.alwaysShowSign);

    return `${signum}${formatCurrency(amount, currency, formattingType)}`;
}

function sign(amount: string, alwaysShowSign: boolean = false): string {
    if (!alwaysShowSign) {
        return '';
    }

    const num = Number(amount);
    if (num > 0) {
        return '+';
    }
    return '';
}

/** The amount in `en`, grouped (`1,234.50`); the type's digits are a minimum, Intl rounds at max(it, 3). */
export function formatAmount(value: MonetaryValue | null, formattingType: FormattingType): MonetaryValue | null {
    if (!value) {
        return null;
    }

    const amount = extractAmountFromMonetaryValue(value);
    const currency = value.currency;

    const { minimumFractionDigits } = formattingOptions[formattingType];
    const formattedAmount = getOrCreateNumberFormatter('en', { minimumFractionDigits }).format(Number(amount));

    return {
        amount: formattedAmount,
        currency,
    };
}
